<template>
	<Popper :arrow="true" :placement="'top-start'" hover>
		<div class="cursor-pointer">
			<img src="@/assets/images/icons/info-circle-line.png" alt="" />
		</div>
		<template #content>
			<div style="max-width: 360px" class="text-lg text-neutral-600">
				<div class="font-semibold">Học phí thu được/dự kiến:</div>
				<div class="font-normal">
					{{ $filters.priceFormat(notice?.total_tuition_price_paid) }}/{{
						$filters.priceFormat(notice?.total_tuition_price)
					}}
					VNĐ
				</div>
				<div class="font-semibold mt-4">Đã đóng học phí:</div>
				<div class="font-normal">
					{{ notice?.paid_count }}/{{ notice?.total_tuition_count }} học
					sinh
				</div>
			</div>
		</template>
	</Popper>
</template>
<script>
import Popper from 'vue3-popper';

export default {
	name: 'FeePoper',
	components: { Popper },

	props: {
		notice: {
			type: Object,
			required: true,
		},
	},
};
</script>
